import React from "react";

import { PageMessage } from "@picklebet/ui";
import { LinkButton } from "@/features/shell/components/shared/LinkButton/LinkButton";

import { ReactComponent as ErrorIcon } from "assets/illustrations/account-error.svg";

type CheckNeedsReopenProps = {
  permission: string;
  children?: React.ReactNode;
};

const CheckNeedsReopen = ({ children, permission }: CheckNeedsReopenProps) => {
  if (permission === "ACCOUNT_REOPEN_REQUIRED") {
    return (
      <PageMessage
        image={<ErrorIcon />}
        title={`Requires Re-open`}
        subTitle={`You need to re-open your account to access this page.`}
      >
        <LinkButton to={`/account/reopen`}>Re-open</LinkButton>
      </PageMessage>
    );
  }

  return <>{children}</>;
};

export { CheckNeedsReopen };
